import PopupMenu from "@/views/PushNotification/UIComponents/PopupMenu"
import firebase from 'firebase/app'
import 'firebase/auth'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VueSimpleAlert from "vue-simple-alert"
import App from './App.vue'
import router from './router'
import store from './store'
import tokenManagerService from "./services/tokenManager"
import { permissionsMixin } from './mixins/permissions.mixin'



const configOptions = {
  apiKey: "AIzaSyA4dk01ppmVxSo-_VZZCFLfdiQOH5FEZpM",
  authDomain: "codeway-shared.firebaseapp.com",
  databaseURL: "https://codeway-shared.firebaseio.com",
  projectId: "codeway-shared",
  storageBucket: "codeway-shared.appspot.com",
  messagingSenderId: "821633703997",
  appId: "1:821633703997:web:4645f51ab4c9114a564a54"
};

firebase.initializeApp(configOptions);

firebase.auth().onAuthStateChanged( user => {
  if (user) {
    console.log("Firebase user is signed in:", user.uid);
  } else {
    console.log("Firebase user is signed out.");
  }
});

// firebase.auth().onAuthStateChanged( async user => {
//   const isStaging = store.getters.isStaging
// // prod and user is logging in
// if(!isStaging && user){
//   const token = await user.getIdTokenResult()
//   const isOnlyStaging = token.claims.isOnlyStaging
//   if(isOnlyStaging){
//     console.log("You are not authorized");
//   }
//   else{
//     store.dispatch("setUser", user);
//   }
// }
// else{
//   store.dispatch("setUser", user);
// }
// });

Vue.component('multiselect', Multiselect)
Vue.component('popup-menu', PopupMenu)
Vue.use(require('vue-moment'));
Vue.use(VueSimpleAlert);

// Register global permissions mixin
Vue.mixin(permissionsMixin);

Vue.config.productionTip = false
// Authentication initialization function
async function initializeAuthentication() {
  try {
    console.log("🔄 Initializing authentication...");
    
    // 1. Initialize the service
    await tokenManagerService.initialize();
    
    // 2. Check for a valid access token (needed for getUserInfo)
    const accessToken = await tokenManagerService.getValidToken();
    debugger;
    if (accessToken) {
      console.log("✅ Valid session found");
      
      // 3. Load user information into Vuex
      try {
        await store.dispatch("setUser"); 
        console.log("✅ User information loaded");
      } catch (err) {
        console.error("❌ Failed to load user profile:", err);
        // Don't allow app to load if we can't get user info - token might be invalid
        return false;
      }
      
      return true;
    } else {
      console.log("ℹ️ No active session found");
      return false;
    }
  } catch (error) {
    console.error("❌ Auth init error:", error);
    return false;
  }
}

// Main application initialization
async function initializeApp() {
  // Default state
  let isAuthenticated = false;

  try {
    // 1. Perform Auth Check before mounting
    // This ensures we don't flash the login screen if the user is actually logged in
    isAuthenticated = await initializeAuthentication();
    
  } catch (error) {
    console.error("Critical initialization failure:", error);
  } finally {
    // 2. Commit final state to store
    store.commit('SET_INITIALIZED', true);
    
    // 3. Mount the App (Single entry point)
    new Vue({
      router,
      store,
      render: h => h(App),
      // We pass the auth state as a prop or data to the root instance
      // so App.vue knows immediately if it should show the layout or login
      data: {
        isAuthenticated
      }
    }).$mount('#app');
    
    console.log(`🚀 Application initialized (Authenticated: ${isAuthenticated})`);
  }
}

// Execute
initializeApp();